export default "__VITE_ASSET__26fc9427__"